/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useEffect, useMemo } from 'react';

import { useCommandIntelligence } from '../CommandIntelligenceContext';
import { buildDefaultGlobalCommandIntelligenceConfig } from './build-default-global-command-intelligence-config';
import { REGISTRATION_KIND_BASE } from './constants';

const CommandIntelligenceGlobalRegistrar = ({ agentRef, enabled = true }) => {
  const { configure, clearConfiguration } = useCommandIntelligence();

  const commandIntelligenceConfig = useMemo(
    () => buildDefaultGlobalCommandIntelligenceConfig({ agentRef }),
    [agentRef]
  );

  useEffect(() => {
    if (!enabled || !agentRef) {
      return undefined;
    }

    configure({
      registrationKind: REGISTRATION_KIND_BASE,
      commandIntelligenceConfig,
      enabled: true,
    });

    return () => {
      clearConfiguration({ registrationKind: REGISTRATION_KIND_BASE });
    };
  }, [agentRef, clearConfiguration, commandIntelligenceConfig, configure, enabled]);

  return null;
};

export default CommandIntelligenceGlobalRegistrar;
